
import { EVENTS } from '../../shared/Events';
import ConfigScene from './ConfigScene';

class SceneManager {
  constructor() {
    // const
    this.OFFSETS = {
      HEAVEN: 0,
      TOWN: ConfigScene.SIZES.SCENE_ACTIVE_HEIGHT - ConfigScene.SIZES.SCENE_CONT_HEIGHT,
    };
    this.ANIM = {
      TIMES: {
        MAIN: 5.5,
        SCALE_IN: 3.7,
        SCALE_OUT: 3.0,
      },
    };
    this.GOD_SNOW_LIMIT = 0.8;

    // vars - base
    this.msFrame = 0;

    // snow
    this.snowMain = 0; // 0-1 - main intensity
    this.snowAngels = [];

    // god
    this.godShown = false;
    this.godResetTimer = null;

    // vars - transition
    this.sceneState = 0; // 0 - town, 1-heaven, -1-transition
    this.sceneDestination = 0; // 0 - town, 1-heaven - for ambi sound
    this.offset = this.OFFSETS.TOWN;
    this.offsetProgress = -1; // -1 - 1
    this.townScale = 0;
    this.firstTransition = true; // for swap sfx

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // listeners
    aScene.signals.sceneCallMain.add(this.callMainFc, this);
  }

  // --------------------------------------------------------------
  // Main Call
  // --------------------------------------------------------------

  callMainFc(sgType) {
    switch (sgType) {
      case EVENTS.MOVE_TO_HEAVEN_START:
        this.moveToHeaven();
        // try reset god
        clearTimeout(this.godResetTimer);
        this.godShown = false;
        break;
      case EVENTS.MOVE_TO_TOWN_START:
        this.moveToTown();
        break;
      default:
    }
  }

  // --------------------------------------------------------------
  // Snow
  // --------------------------------------------------------------

  snowUpdate() {
    this.snowMain = this.snowAngels.reduce((a, b) => {return a + b; }) / this.snowAngels.length;
    if (this.snowMain > this.GOD_SNOW_LIMIT && !this.godShown) {
      this.godShown = true;
      aScene.sndManager.playItemSfx('god');
      aScene.signals.sceneCallMain.dispatch(EVENTS.SHOW_GOD, 4700);
      this.godResetTimer = setTimeout(() => {
        this.godShown = false;
      }, 10000);
      aPage.stats.trackEvent('Snow Max');
    }
  }

  // --------------------------------------------------------------
  // Move - Up
  // --------------------------------------------------------------

  moveToHeaven() {
    this.sceneState = -1;
    this.sceneDestination = 1;
    TweenMax.killTweensOf(this);
    TweenMax.to(this, this.ANIM.TIMES.MAIN, {
      offset: this.OFFSETS.HEAVEN,
      ease: Power3.easeInOut,
      onUpdate: this.moveUpdate,
      onUpdateScope: this,
      onComplete: this.moveToHeavenEnd,
      onCompleteScope: this,
    });
    TweenMax.to(this, this.ANIM.TIMES.SCALE_IN, {
      townScale: 1,
      ease: Power2.easeInOut,
    });
    aScene.sndManager.playSfx(this.firstTransition ? 'transition-1' : 'transition-1-no-music');
  }

  moveToHeavenEnd() {
    this.sceneState = 1;
    aScene.signals.sceneCallMain.dispatch(EVENTS.MOVE_TO_HEAVEN_END);
  }

  // --------------------------------------------------------------
  // Move - Down
  // --------------------------------------------------------------

  moveToTown() {
    this.sceneState = -1;
    this.sceneDestination = 0;
    TweenMax.killTweensOf(this);
    TweenMax.to(this, this.ANIM.TIMES.MAIN, {
      offset: this.OFFSETS.TOWN,
      ease: Power3.easeInOut,
      onUpdate: this.moveUpdate,
      onUpdateScope: this,
      onComplete: this.moveToTownEnd,
      onCompleteScope: this,
    });
    TweenMax.to(this, this.ANIM.TIMES.SCALE_OUT, {
      townScale: 0,
      delay: this.ANIM.TIMES.MAIN - this.ANIM.TIMES.SCALE_OUT,
      ease: Power2.easeOut,
    });
    aScene.sndManager.playSfx(this.firstTransition ? 'transition-0' : 'transition-0-no-music');
  }

  moveToTownEnd() {
    this.firstTransition = false;
    this.sceneState = 0;
    aScene.signals.sceneCallMain.dispatch(EVENTS.MOVE_TO_TOWN_END);
  }

  // --------------------------------------------------------------
  // Move - Shared
  // --------------------------------------------------------------

  moveUpdate() {
    this.offsetProgress = (0.5 - (this.offset / this.OFFSETS.TOWN)) * 2;
  }
}

export default SceneManager;



// WEBPACK FOOTER //
// ./src/js/scene/helpers/SceneManager.js